/**
 * Formata telefone brasileiro para exibição.
 * Celular (11 dígitos): (00) 0 0000-0000
 * Fixo (10 dígitos): (00) 0000-0000
 * Retorna "—" quando vazio; devolve o valor original se não houver dígitos suficientes.
 */
export function formatarTelefoneBr(
  telefone: string | null | undefined,
  fallback = '—'
): string {
  if (telefone == null || String(telefone).trim() === '') {
    return fallback;
  }

  const digitos = String(telefone).replace(/\D/g, '');

  if (digitos.length === 11) {
    return digitos.replace(/^(\d{2})(\d{1})(\d{4})(\d{4})$/, '($1) $2 $3-$4');
  }

  if (digitos.length === 10) {
    return digitos.replace(/^(\d{2})(\d{4})(\d{4})$/, '($1) $2-$3');
  }

  return String(telefone).trim();
}
